import React, { useMemo, useCallback } from "react";
import { Input, Select, message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import BJCA from "@/utils/XTXSAB";
import { analysisLog } from "@/utils/logAnalytics";
import { LoginFormContext, LoginFormContextType } from "../../../utils";
import isUndefined from "lodash/isUndefined";
import colors from "@/components/styles/colors";
import styles from "../../../index.module.less";
import styles1 from "../index.module.less"

const { Option } = Select;

function CaInputComp(props: any) {
  const { setLoading, onSelAccount, setNextStepInstance, onLoginModeChange } = props;
  const [caPwd, setCaPwd] = React.useState("");
  const [certId, setCertId] = React.useState("");
  const [infoModal, setInfoModal] = React.useState(false);

  const { onGlobalError, appRuntimeEnv, service, focusSDK } =
    React.useContext<GlobalContextConfig>(GlobalContext);
  const { onLoginTypeChange, selectedTeam } =
    React.useContext<LoginFormContextType>(LoginFormContext);

  const { t } = useTranslation();
  const [certList, setCertList] = React.useState([]);
  const isWin = appRuntimeEnv.platform === "WINDOWS" || appRuntimeEnv.platform === "WEB";

  const getUserListCb = React.useCallback(
    (data: any) => {
      if (data) {
        const ret = data.retVal;
        if (ret) {
          const cList = ret
            .split("&&&")
            .filter((el: any) => el)
            .map((el: any) => {
              const [name, id] = el.split("||");
              return { id, name };
            });
          setCertList(cList);
          setCertId(cList[0].id);
          onLoginTypeChange("MOBILE");
        } else {
          setCertList([]);
          setCertId("");
          setCaPwd("");
          // focusSDK.logout();
          // message.warn('未找到CA证书');
        }
      }
    },
    [setCertList, onLoginTypeChange]
  );

  const checkCaPwd = useCallback(async () => {
    setLoading(true);
    const submitLoginCallback = async (retObj: any) => {
      setLoading(true);
      try {
        const strClientRan = retObj.retVal;
        const { strUserCert, strSignedData } = retObj.ctx;
        const params = {
          userCert: strUserCert,
          userSignedData: strSignedData,
          strRandom: strClientRan
        };
        // const submitLoginRes = await service.authService.loginByCertificationAuthority(params);
        const submitLoginRes = await service.authService.ticketLoginByCertificationAuthority(
          params
        );
        if (submitLoginRes.publicAccountList && submitLoginRes.publicAccountList.length) {
          onSelAccount(submitLoginRes, "caCert");
        } else if (submitLoginRes.loginStatus.toLowerCase() === "normal") {
          selectedTeam(submitLoginRes);
        } else {
          message.error("证书认证错误，请联系单位管理员！");
        }
      } catch (e) {
        message.error("证书认证错误，请联系单位管理员！");
      }
      setLoading(false);
    };

    try {
      CALogin(certId, caPwd, submitLoginCallback);
    } catch (e) {
      message.error("证书认证错误，请联系单位管理员！");
    }
    setLoading(false);
    // @ts-ignore
    // window.VerifyUserPIN(certId, caPwd, async (data: any) => {
    //     const { retVal } = data || {};
    //     if (retVal) {
    //         try {
    //             // @ts-ignore
    //             window.GetSignCert(certId, (data) => {
    //             });
    //             // const securityRes = await service.authService.getCaServerSecurity();
    //             // const { strServerCert, strServerRan, strSignedData } = securityRes;
    //             message.success('登录成功');
    //         } catch (err) {
    //             console.log(err);
    //         }
    //     } else {
    //         // @ts-ignore
    //        window.SOF_GetPinRetryCount(certId, (res: any) => {
    //             const { retVal: retryCount } = res;
    //             if (retryCount > 0) {
    //                 message.error('校验证书密码失败!您还有' + retryCount + '次机会重试!');
    //             } else if (retryCount === 0) {
    //                 message.error('您的证书密码已被锁死,请联系BJCA进行解锁!');
    //             } else {
    //                 message.error('登录失败');
    //             }
    //         });
    //     }
    // });
  }, [service.authService, CALogin, selectedTeam, certId, caPwd]);

  const CALogin = useCallback((certId, caPwd, callback) => {
    analysisLog("xtbg_pc_login_1687846230535", "5");
    /*eslint-disable*/
    BJCA.SOF_Login(certId, caPwd, async (data: any) => {
      if (!data.retVal) {
        message.error(t("login.pwdFailed"));
        return;
      }
      try {
        const securityRes = await service.authService.getCaServerSecurity();
        const { strServerCert, strServerRan, strSignedData } = securityRes;
        if (!strServerCert || !strServerRan || !strSignedData) {
          throw new Error();
        }
        BJCA.SOF_Base64Encode(strServerRan, () => {
          BJCA.SOF_SignData(certId, strServerRan, (signVal: any) => {
            BJCA.SOF_ExportUserCert(certId, (certVal: any) => {
              callback({
                retVal: strServerRan,
                ctx: {
                  strUserCert: certVal.retVal,
                  strSignedData: signVal.retVal
                }
              });
            });
          });
        });
      } catch (e) {
        message.error("证书认证错误，请联系单位管理员！");
      }
    });
  }, []);

  const canRegister = useMemo(() => {
    const canReg = appRuntimeEnv.getUIConfig("canRegister");
    if (!isUndefined(canReg) && !canReg) {
      return false;
    }
    return true;
  }, [appRuntimeEnv]);
  // 证书登录使用说明
  const caInputCompSm = (
    <>
      <div
        style={{
          fontSize: "12px",
          color: `${colors.primary2}`,
          cursor: "pointer"
        }}
        onClick={() => setInfoModal(true)}
      >
        证书登录使用说明
      </div>
      <Modal
        className={styles.Notice}
        title="证书登录使用说明"
        visible={infoModal}
        onCancel={() => {
          setInfoModal(false);
        }}
        footer={null}
        centered={true}
      >
        <div>
          <p>
            1、
            {(window as any)?._BTS_CONFIG?.REACT_APP_NAME || process.env.REACT_APP_NAME || ""}
            平台的证书登录需要使用信创版证书助手及信创版USBKEY访问登录；
          </p>
          <p>
            2、关于账号注册、证书申领、证书助手安装以及相关使用操作请联系上级单位或本单位证书管理员；
          </p>
          <p>3、关于证书到期更新、丢失、损坏补办等问题可联系单位证书管理员。</p>
        </div>
      </Modal>
    </>
  );

  React.useEffect(() => {
    if (isWin) {
      BJCA.init(
        function () {
          // @ts-ignore
          window.SOF_GetUserList(getUserListCb);
        },
        function () {
          // if 是 CA 登录的
          // focusSDK.getAuthInfo((userData: AuthData) => {
          //     console.log('userData', userData);
          // });
          // sunxiaolin3 暂时禁止登出 （影响扫码登陆，登录页频繁切换登录方式  确定二维码登录后  二维码登录获取频繁失败）
          // focusSDK.logout();
        }
      );
      BJCA.SetAlertFunction((strMsg: string) => {
        message.warn(strMsg);
      });
    }
  }, [isWin, appRuntimeEnv.platform, setCertList, getUserListCb, focusSDK]);

  React.useEffect(() => {
    setNextStepInstance({
      valid: !!certId && !!caPwd,
      onClick: checkCaPwd
    });
  }, [setNextStepInstance, certId, caPwd, checkCaPwd]);
  return (
    <>
      <div>
        <div className={`mobileInput1`} style={{marginTop: 4, marginBottom: 8}}>
          <Select
            defaultValue="证书编号"
            placeholder="证书编号"
            style={{
              width: "100%",
              color: "rgba(0, 0, 0, 0.35)",
            }}
          >
            {certList.length > 0 ? (
              certList.map((el: any) => (
                <Option className={styles.mobileInputOption} value={el.id} key={el.id}>
                  {el.name}
                </Option>
              ))
            ) : (
              <Option className={styles.mobileInputOption} value="暂无数据" disabled>
                暂无数据
              </Option>
            )}
          </Select>
        </div>
        <div className={styles1["mobile_input"]} style={{marginBottom: 12}}>
          <Input
            placeholder={t("login.inputCaPwdPl")}
            value={caPwd}
            type="password"
            onKeyDown={(e: any) => {
              const { keyCode } = e;
              if (keyCode === 13) {
                checkCaPwd();
              }
            }}
            onChange={(e: any) => {
              setCaPwd(e.target.value);
            }}
            allowClear
          />
        </div>
        {canRegister && (
          <span className={styles.noAccount}>
            {t("login.haveNoAccount")}？
            <a onClick={() => onLoginModeChange("register")}>{t("login.signupNow")}</a>
          </span>
        )}
        {caInputCompSm}
      </div>
    </>
  );
}

export default CaInputComp;
